import {
  useToast,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  Flex,
  CloseButton,
  HStack,
  VStack,
} from "@chakra-ui/react";
import { useCallback } from "react";
import { theme } from "src/styles/theme";

interface MessageParams {
  message: string;
  whiteSpace?: any;
}
interface TitleAndMessageParams {
  title: string;
  message: any;
  whiteSpace?: any;
}

export const useMessageErrorToast = () => {
  const toast = useToast();

  const displayMessageError = useCallback(
    ({ message, whiteSpace = undefined }: MessageParams) => {
      toast.closeAll();
      toast({
        status: "error",
        isClosable: true,
        duration: 5000,
        position: "top-right",
        render: () => (
          <Alert
            status="error"
            variant="solid"
            borderRadius="md"
            boxShadow="lg"
            alignItems="flex-start"
            p={4}
            pr={4}
            height="auto"
            width="100%"
            maxW={{ base: "90vw", md: "400px" }}
            justifyContent="space-between"
          >
            <Box
              flex="1"
              display={"flex"}
              width="100%"
              justifyContent="space-between"
              alignItems={"flex-start"}
            >
              <Flex align={"center"}>
                <AlertDescription display="block" whiteSpace={whiteSpace}>
                  {message}
                </AlertDescription>
              </Flex>
            </Box>
            <Box display={"flex"} mt={"-14px"} mr={"-14px"} w={"fit-content"}>
              <CloseButton onClick={() => toast.closeAll()} size="sm" />
            </Box>
          </Alert>
        ),
        containerStyle: {
          w: "fit-content",
          boxShadow: "dark-lg",
          borderRadius: "8px",
        },
      });
    },
    [toast]
  );

  return displayMessageError;
};

export const useTitleAndMessageErrorToast = () => {
  const toast = useToast();

  const displayMessageError = useCallback(
    ({ title, message, whiteSpace = undefined }: TitleAndMessageParams) => {
      toast.closeAll();
      toast({
        status: "error",
        isClosable: true,
        duration: 6000,
        position: "top-right",
        render: () => (
          <Alert
            status="error"
            variant="solid"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            borderRadius="md"
            boxShadow="lg"
            p={4}
            pr={4}
            height="auto"
            width="100%"
            maxW={{ base: "90vw", md: "400px" }}
          >
            {/* <Box
              flex="1"
              display={"flex"}
              width="100%"
              justifyContent="space-between"
              alignItems={"flex-start"}
            >
              <Flex align={"center"}>
                <AlertDescription display="block" whiteSpace={whiteSpace}>
                  {message}
                </AlertDescription>
              </Flex>
            </Box> */}
            <HStack
              width="100%"
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <AlertTitle
                fontSize="md"
                fontWeight="bold"
                whiteSpace={whiteSpace}
              >
                {title}
              </AlertTitle>
              <CloseButton onClick={() => toast.closeAll()} size="sm" />
            </HStack>

            <VStack spacing={1} width="100%" mt={2} mb={2}>
              <AlertDescription fontSize="sm" whiteSpace={whiteSpace}>
                {message}
              </AlertDescription>
            </VStack>

            {/* <Box display={"flex"} mt={"-14px"} mr={"-14px"} w={"fit-content"}>
              <CloseButton onClick={() => toast.closeAll()} size="sm" />
            </Box> */}
          </Alert>
        ),
        containerStyle: {
          w: "fit-content",
          boxShadow: "dark-lg",
          borderRadius: "8px",
        },
      });
    },
    [toast]
  );

  return displayMessageError;
};
